import React, { createContext, ReactNode, useContext, useState } from 'react';
import { findBestLocaleFromString } from '../utils/locale';

export type AppLocale = {
  locale: string;
  localeId: number;
};

export const EN = { locale: 'en', localeId: 1033 };
export const TH = { locale: 'th', localeId: 1054 };

export type LocaleContextType = {
  appLocale: AppLocale;
  locale: string;
  localeId: number;
  setAppLocale: (locale: AppLocale | string) => void;
};

export const LocaleContext = createContext({
  appLocale: EN,
  locale: 'en',
  localeId: 1033,
  setAppLocale: () => {},
} as LocaleContextType);

export const useAppLocaleContext = () => {
  return useContext(LocaleContext);
};

export const AppLocaleProvider = ({ initLocale, children }: { initLocale: AppLocale; children: ReactNode }) => {
  const [locale, setLocale] = useState<AppLocale>(initLocale);

  const setAppLocale = (locale: AppLocale | string) => {
    if (typeof locale === 'string') {
      setLocale(findBestLocaleFromString(locale));
    } else {
      setLocale(locale);
    }
  };

  return (
    <LocaleContext.Provider
      value={{
        appLocale: locale,
        locale: locale.locale,
        localeId: locale.localeId,
        setAppLocale: setAppLocale,
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
};
